(() => {
  if (window.__optimateCartEventsBound) return;
  window.__optimateCartEventsBound = true;

  let themeColorMeta = document.querySelector('meta[name="theme-color"]');
  const originalThemeColor = themeColorMeta?.getAttribute('content') ?? null;
  let createdThemeColorMeta = false;

  function setWhiteBrowserChrome(active) {
    document.documentElement.classList.toggle(
      'optimate-cart-open-white',
      active
    );

    document.body?.classList.toggle(
      'optimate-cart-open-white',
      active
    );

    if (active) {
      if (!themeColorMeta) {
        themeColorMeta = document.createElement('meta');
        themeColorMeta.name = 'theme-color';
        document.head.appendChild(themeColorMeta);
        createdThemeColorMeta = true;
      }

      themeColorMeta.setAttribute('content', '#ffffff');
      return;
    }

    if (createdThemeColorMeta && themeColorMeta) {
      themeColorMeta.remove();
      themeColorMeta = null;
      createdThemeColorMeta = false;
    } else if (themeColorMeta && originalThemeColor !== null) {
      themeColorMeta.setAttribute('content', originalThemeColor);
    } else if (themeColorMeta) {
      themeColorMeta.removeAttribute('content');
    }
  }

  function syncDrawerChrome() {
    const drawer = document.querySelector('cart-drawer');
    setWhiteBrowserChrome(Boolean(drawer?.classList.contains('active')));
  }

  function closeOptimateCart(drawer) {
    if (!drawer) return;

    drawer.classList.remove('active', 'animate');
    document.body.classList.remove('overflow-hidden');
    setWhiteBrowserChrome(false);

    const overlay = drawer.querySelector('.cart-drawer__overlay');
    if (overlay) overlay.style.pointerEvents = 'none';
  }

  function prepareOpenedCart(drawer) {
    if (!drawer) return;

    drawer.classList.remove('is-empty');
    setWhiteBrowserChrome(true);

    const inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    const overlay = drawer.querySelector('.cart-drawer__overlay');
    if (overlay) overlay.style.pointerEvents = '';
  }

  function closeDrawer(drawer) {
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    }

    closeOptimateCart(drawer);
  }

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const closeButton = target.closest('cart-drawer .drawer__close');

    if (closeButton) {
      event.preventDefault();
      closeDrawer(closeButton.closest('cart-drawer'));
      return;
    }

    const overlay = target.closest('cart-drawer .cart-drawer__overlay');

    if (overlay) {
      closeDrawer(overlay.closest('cart-drawer'));
      return;
    }

    const button = target.closest('.optimate-upsell-card__add');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const originalText = button.textContent;
    const root = window.Shopify?.routes?.root || '/';

    button.disabled = true;
    button.textContent = '...';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: `${window.location.pathname}${window.location.search}`
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description || data.message || 'The product could not be added.'
        );
      }

      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        prepareOpenedCart(drawer);
        drawer.renderContents(data);

        window.requestAnimationFrame(() => {
          prepareOpenedCart(drawer);
        });
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Upsell add-to-cart error:', error);
      button.disabled = false;
      button.textContent = originalText;
      window.alert(error.message || 'The product could not be added.');
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;

    const drawer = document.querySelector('cart-drawer.active');
    if (drawer) closeDrawer(drawer);
  });

  const drawerObserver = new MutationObserver((mutations) => {
    if (
      mutations.some(
        (mutation) =>
          mutation.target instanceof Element &&
          mutation.target.matches('cart-drawer')
      )
    ) {
      syncDrawerChrome();
    }
  });

  drawerObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true
  });

  syncDrawerChrome();
})();
